<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">Add Merchandise Tags</div>
    </div>
    <div class="white-wrapper" style="zoom: 0.9">
      <form class="row">
        <div class="col-lg-4 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="m_tag_name"
                type="text"
                name="m_tag_name"
                id="m_tag_name"
              />
              <label>Tag Name</label>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="resetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="merchandise-tags"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      m_tag_name: "",
      tag_is_active: "Y",
      submitted: false,
    };
  },
  mounted() {},
  methods: {
    OnFinalSubmit: function (redirect) {
      this.submitted = true;
      if (!this.m_tag_name) {
        return this.$toasted.show("Please Enter Tag Name");
      } else {
        let payload = {
          m_tag_name: this.m_tag_name,
          tag_is_active: "Y",
        };
        MasterService.AddMerchandiseTag(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;
            if (data && data.status) {
              this.resetForm();
              if (redirect) {
                this.$router.push({
                  path: "merchandise-tags",
                });
              }
              this.submitted = false;
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      }
    },
    resetForm: function () {
      this.m_tag_name = "";
      this.tag_is_active = "Y";
      this.btenable = false;
      this.submitted = false;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/MechandiseComponents/AddMerchandiseTag.vue